// src/components/Footer.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const navigate = useNavigate();

  const handleTeklifClick = (e) => {
    e.preventDefault();
    // AnaSayfa’ya git ve form alanına scroll yap
    navigate('/', { state: { scrollToTeklif: true } });
  };

  return (
    <footer className="apple-style-footer">
      <div className="footer-grid">
        {/* Brand */}
        <div className="footer-col brand-col">
          <h2 className="footer-brand">Air Makina</h2>
          <p className="footer-description">
            30 yıllık sektör tecrübesiyle endüstriyel hava sistemlerinde güvenilir çözüm ortağınız.
          </p>
        </div>

        {/* Contact */}
        <div className="footer-col">
          <h3 className="footer-heading">İletişim</h3>
          <div className="contact-item">
            <PhoneIcon />
            <span>0541 332 91 63</span>
          </div>
          <div className="contact-item">
            <LocationIcon />
            <span>Yeşiloba Mah., 46205 Sk. No:17/4B, Adana</span>
          </div>
          <div className="contact-item">
            <EmailIcon />
            <span>info@airmakina.com.tr</span>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h3 className="footer-heading">HIZLI LİNKLER</h3>
          <ul className="footer-links">
            <li><a href="/">Ana Sayfa</a></li>
            <li><a href="/" onClick={handleTeklifClick}>Teklif al</a></li>
            <li><a href="/urunler">Ürünler</a></li>
            <li><a href="/hizmetler">Hizmetler</a></li>
            <li><a href="/iletisim">İletişim</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-divider"></div>

      <div className="footer-copyright">
        <p>© {new Date().getFullYear()} Air Makina İmalat Sanayi ve Ticaret Ltd. Şti. Tüm hakları saklıdır.</p>
        <p className="footer-legal">
          <a href="/gizlilik">Gizlilik Politikası</a> • 
          <a href="/kullanim">Kullanım Şartları</a>
        </p>
      </div>
    </footer>
  );
};

// 📞 Telefon İkonu
const PhoneIcon = () => (
  <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 11.5L10 9M6 7L3.5 4.5M10 13H13V10M3 6V3H6M10.5 11.5C10.5 11.5 11 12 12 12C13 12 13.5 11.5 13.5 11.5C13.5 11.5 14 11 14 10C14 9 13.5 8.5 13.5 8.5M2.5 7.5C2.5 7.5 2 7 1 7C0 7 0.5 7.5 0.5 7.5C0.5 7.5 0 8 0 9C0 10 0.5 10.5 0.5 10.5" 
          stroke="#86868B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// 📍 Lokasyon İkonu
const LocationIcon = () => (
  <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" 
          stroke="#86868B" strokeWidth="1.5" />
    <circle cx="8" cy="8" r="2" fill="#86868B" />
  </svg>
);

// ✉️ Email İkonu
const EmailIcon = () => (
  <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 4L8 8L14 4M2 4H14V12H2V4Z" 
          stroke="#86868B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Footer;
